import $ from "jquery";

const getHash = () => {
	const raw = window.location.hash.replace(/^#/, "");

	if (!raw) {
		return "";
	}

	try {
		return decodeURIComponent(raw);
	} catch (error) {
		return raw;
	}
};

const setOpen = ($item, isOpen) => {
	const $content = $item.children(".kiwi-accordion__content");
	const $button = $item.find(".kiwi-accordion__header").first();

	$item.toggleClass("is-open", isOpen);
	$button.attr("aria-expanded", isOpen ? "true" : "false");
	$content.css("max-height", isOpen ? `${$content.prop("scrollHeight")}px` : "0px");
};

const openOnly = ($item, shouldScroll) => {
	const $accordion = $item.closest(".kiwi-accordion");

	$accordion.children(".kiwi-accordion__item").each(function () {
		setOpen($(this), this === $item.get(0));
	});

	if (shouldScroll && $item.get(0)) {
		window.requestAnimationFrame(() => {
			$item.get(0).scrollIntoView({ behavior: "smooth", block: "start" });
		});
	}
};

const openFromHash = (shouldScroll) => {
	const hash = getHash();

	if (!hash) {
		return false;
	}

	const el = document.getElementById(hash);

	if (!el || !el.classList.contains("kiwi-accordion__item")) {
		return false;
	}

	openOnly($(el), shouldScroll);
	return true;
};

const closeAll = ($accordion) => {
	$accordion.children(".kiwi-accordion__item").each(function () {
		setOpen($(this), false);
	});
};

const clearItemHash = (id) => {
	if (!id || getHash() !== id) {
		return;
	}

	window.history.pushState(
		null,
		"",
		`${window.location.pathname}${window.location.search}`,
	);
};

const refreshOpenHeights = () => {
	$(".kiwi-accordion__item.is-open").each(function () {
		setOpen($(this), true);
	});
};

const PIN_FALLBACK_MS = 400;
let stopActivePin = null;

const pinHeader = (header, targetTop) => {
	const accordion = header.closest(".kiwi-accordion");

	if (!accordion) {
		return;
	}

	if (stopActivePin) {
		stopActivePin(false);
	}

	let running = true;
	let frameId = 0;
	let timeoutId = 0;

	const correct = () => {
		const drift = header.getBoundingClientRect().top - targetTop;

		if (Math.abs(drift) > 0.5) {
			window.scrollTo({
				top: window.scrollY + drift,
				behavior: "instant",
			});
		}
	};

	const onTransitionEnd = (event) => {
		if (event.propertyName !== "max-height") {
			return;
		}

		if (
			!event.target.classList ||
			!event.target.classList.contains("kiwi-accordion__content")
		) {
			return;
		}

		stop();
	};

	const stop = (shouldCorrect = true) => {
		if (!running) {
			return;
		}

		running = false;
		window.cancelAnimationFrame(frameId);
		window.clearTimeout(timeoutId);
		accordion.removeEventListener("transitionend", onTransitionEnd);

		if (stopActivePin === stop) {
			stopActivePin = null;
		}

		if (shouldCorrect) {
			correct();
		}
	};

	stopActivePin = stop;
	accordion.addEventListener("transitionend", onTransitionEnd);
	timeoutId = window.setTimeout(stop, PIN_FALLBACK_MS);

	const tick = () => {
		if (!running) {
			return;
		}

		correct();
		frameId = window.requestAnimationFrame(tick);
	};

	frameId = window.requestAnimationFrame(tick);
};

const initAccordions = () => {
	$(".kiwi-accordion").each(function () {
		const $accordion = $(this);

		if ($accordion.data("kiwiAccordion")) {
			return;
		}

		$accordion.data("kiwiAccordion", true);

		$accordion.get(0).addEventListener(
			"load",
			(event) => {
				if (event.target.tagName !== "IMG") {
					return;
				}

				const item = event.target.closest(".kiwi-accordion__item");

				if (item && item.classList.contains("is-open")) {
					setOpen($(item), true);
				}
			},
			true,
		);

		$accordion.on("click", ".kiwi-accordion__header", function () {
			const $item = $(this).closest(".kiwi-accordion__item");
			const id = $item.attr("id");

			if ($item.hasClass("is-open")) {
				setOpen($item, false);
				clearItemHash(id);
				return;
			}

			const header = this;
			const targetTop = header.getBoundingClientRect().top;

			openOnly($item, false);
			pinHeader(header, targetTop);

			if (id) {
				window.history.pushState(null, "", `#${id}`);
			}
		});
	});

	if (!openFromHash(true)) {
		$(".kiwi-accordion").each(function () {
			closeAll($(this));
		});
	}

	$(window).on("hashchange", () => {
		if (!openFromHash(true) && !getHash()) {
			$(".kiwi-accordion").each(function () {
				closeAll($(this));
			});
		}
	});

	$(window).on("resize load", refreshOpenHeights);
};

$(() => {
	initAccordions();
});

export default initAccordions;
